import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalHorariosFrequencias from "../../_Aux/ModalHorariosFrequencias";
import ModalGerarDocumento from "../../../../shared/components/Modals/GerarDocumento";
import ModalAta from "../../../Aproveitamento/Relatorios/Drawer/Ata";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

function Opcoes(props) {
    const disciplinaId = localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso");

    // EXPORTAR
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [fichaExcel, setFichaExcel] = useState(false);

    // LOADING
    const [visibleLoading, setVisibleLoading] = useState(false);

    // VIEWER
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [docs, setDocs] = useState([]);

    const entidadeId = localStorage.getItem("entidade_id");

    // Modal horários / frequências
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Estes campos já eram usados via this.state no código original
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [periodoId] = useState(undefined); // caso seja definido noutro sítio

    const exportar = () => {
        setVisibleExportar(true);
        setBtnDescarregar(true);

        axios({
            method: "get",
            url: "/api/excel/faltas-horas",
            params: {
                cursoId: disciplinaId
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleExportar(false);
            });
    };

    const exportarPdf = (disciplina, option, startDate, endDate, dataEmissao) => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/frequencia-pdf",
            params: {
                cursoId: disciplina,
                periodoId: periodoId,
                start: moment(startDate).format("YYYY/MM/DD"),
                end: moment(endDate).format("YYYY/MM/DD"),
                tipo: option,
                dataEmissao: moment(dataEmissao).format("YYYY/MM/DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const ExportarExcel = dataEmissao => {
        setVisibleExportar(true);
        setBtnDescarregar(true);
        axios({
            method: "get",
            url: "/api/excel/excel-ouro-branco",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: moment(dataEmissao).format("DD/MM/YYYY")
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data.url);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const toggleModal = () => {
        setIsModalVisible(prev => !prev);
    };

    return (
        <>
            <div className="bloco-opcoes-esquerda">
                <Link className={`botao-icon-detalhe botao-maior`} to="#" title="Descarregar" onClick={toggleModal}>
                    <Icon type="eye" />
                </Link>

                {entidadeId === "37" && localStorage.getItem("vista") === "TURMA" ? (
                    <>
                        {!disciplinaId ? (
                            <Link className={`botao-icon-excel botao-maior`} to="#" title="Descarregar" onClick={() => setFichaExcel(true)}>
                                <Icon type="download" />
                            </Link>
                        ) : (
                            <Link
                                className={`botao-icon-download botao-maior ${!disciplinaId ? "botao-disabled" : ""}`}
                                to="#"
                                title="Descarregar"
                                disabled={!disciplinaId}
                                style={{ margin: 0 }}
                                onClick={exportar}
                            >
                                <Icon type="download" />
                            </Link>
                        )}
                    </>
                ) : (
                    <Link
                        className={`botao-icon-download botao-maior ${
                            localStorage.getItem("vista") === "TURMA" && !disciplinaId ? "botao-disabled" : ""
                        }`}
                        to="#"
                        title="Descarregar"
                        disabled={localStorage.getItem("vista") === "TURMA" && !disciplinaId}
                        style={{ margin: 0 }}
                        onClick={exportar}
                    >
                        <Icon type="download" />
                    </Link>
                )}

                <Link
                    to={`/gerir-detalhe-turma/${props.match.params.turma}/${
                        localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                    }`}
                    className="botao-secundario botao-secundario-redondo"
                    title="Voltar"
                    style={{
                        marginRight: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Icon type="arrow-left" />
                </Link>
            </div>

            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
            />

            <ModalLoading visible={visibleLoading} text="A gerar documento..." />

            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />

            <ModalHorariosFrequencias
                disciplina={disciplinaId}
                visible={isModalVisible}
                onClose={toggleModal}
                onSelect={(option3, option1, option2, dataEmissao) => {
                    setStartDate(option2.start_date);
                    setEndDate(option2.end_date);

                    exportarPdf(option3, option1, option2.start_date, option2.end_date, dataEmissao);
                }}
            />

            <ModalAta
                visible={fichaExcel}
                onClose={() => setFichaExcel(false)}
                onConfirm={dataEmissao => {
                    ExportarExcel(dataEmissao);
                    setFichaExcel(false);
                }}
            />
        </>
    );
}

export default withRouter(Opcoes);
